import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {animationsPageText as animationsPageText_en} from "../libs/en/texts-animations-page-lib";
import {animationsPageText as animationsPageText_en_ca} from "../libs/en-ca/texts-animations-page-lib";
import {animationsPageText as animationsPageText_de} from "../libs/de/texts-animations-page-lib";
import {animationsPageText as animationsPageText_de_ch} from "../libs/de-ch/texts-animations-page-lib";
import {animationsPageText as animationsPageText_fr} from "../libs/fr/texts-animations-page-lib";
import {animationsPageText as animationsPageText_fr_fr} from "../libs/fr-fr/texts-animations-page-lib";
import {animationsPageText as animationsPageText_fr_ca} from "../libs/fr-ca/texts-animations-page-lib";
import {animationsPageText as animationsPageText_nl} from "../libs/nl/texts-animations-page-lib";
import {animationsPageText as animationsPageText_it} from "../libs/it/texts-animations-page-lib";
import {animationsPageText as animationsPageText_it_ch} from "../libs/it-ch/texts-animations-page-lib";
import {animationsPageText as animationsPageText_cz} from "../libs/cz/texts-animations-page-lib";
import {animationsPageText as animationsPageText_fi} from "../libs/fi/texts-animations-page-lib";
import {animationsPageText as animationsPageText_pl} from "../libs/pl/texts-animations-page-lib";
import {animationsPageText as animationsPageText_se} from "../libs/se/texts-animations-page-lib";
import {animationsPageText as animationsPageText_no} from "../libs/no/texts-animations-page-lib";
import {animationsPageText as animationsPageText_dk} from "../libs/dk/texts-animations-page-lib";
import {animationsPageText as animationsPageText_es} from "../libs/es/texts-animations-page-lib";
import {animationsPageText as animationsPageText_pt} from "../libs/pt/texts-animations-page-lib";
import parse from "html-react-parser";
import {GOOGLE_PLAY_APP_URL, APPLE_APP_STORE_URL} from "../utils/appStoreLinks";
import {Helmet} from 'react-helmet';
import {createGridSwipeHandlers} from '../utils/gridSwipeScroll';
import {isDanaOnlyResource, isDanaResourcesAvailable} from '../utils/language';
import {isMgDlAnimation, isMmolLAnimation, usesMgDlGlucoseUnit, usesMmolLGlucoseUnit} from '../utils/countries';

export class Animations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            animationsPageText: animationsPageText_en,
            prefix: '',
            activeFilter: 'ypso',
            sortBy: 'popular',
            currentSlide: 0,
            isVideoOpen: false,
            selectedVideo: null,
            sortDropdownOpen: false
        };
        this.sortContainer = React.createRef();
        const gridSwipeHandlers = createGridSwipeHandlers(this);
        this.handleGridTouchStart = gridSwipeHandlers.onTouchStart;
        this.handleGridTouchEnd = gridSwipeHandlers.onTouchEnd;
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.prevSlide = this.prevSlide.bind(this);
        this.openVideo = this.openVideo.bind(this);
        this.closeVideo = this.closeVideo.bind(this);
        this.toggleSortDropdown = this.toggleSortDropdown.bind(this);
        this.handleSortClickOutside = this.handleSortClickOutside.bind(this);
        if (this.state.language === "DE") {
            this.state.animationsPageText = animationsPageText_de;
            this.state.prefix = '/de';
        }
        if (this.state.language === "DE-CH") {
            this.state.animationsPageText = animationsPageText_de_ch;
            this.state.prefix = '/de-ch';
        }
        if (this.state.language === "EN-CA") {
            this.state.animationsPageText = animationsPageText_en_ca;
            this.state.prefix = '/en-ca';
        }
        if (this.state.language === "FR-FR") {
            this.state.animationsPageText = animationsPageText_fr_fr;
            this.state.prefix = '/fr';
        }
        if (this.state.language === "FR") {
            this.state.animationsPageText = animationsPageText_fr;
            this.state.prefix = '/fr-ch';
        }
        if (this.state.language === "FR-CA") {
            this.state.animationsPageText = animationsPageText_fr_ca;
            this.state.prefix = '/fr-ca';
        }
        if (this.state.language === "NL") {
            this.state.animationsPageText = animationsPageText_nl;
            this.state.prefix = '/nl';
        }
        if (this.state.language === "IT") {
            this.state.animationsPageText = animationsPageText_it;
            this.state.prefix = '/it';
        }
        if (this.state.language === "IT-CH") {
            this.state.animationsPageText = animationsPageText_it_ch;
            this.state.prefix = '/it-ch';
        }
        if (this.state.language === "CZ") {
            this.state.animationsPageText = animationsPageText_cz;
            this.state.prefix = '/cz';
        }
        if (this.state.language === "FI") {
            this.state.animationsPageText = animationsPageText_fi;
            this.state.prefix = '/fi';
        }
        if (this.state.language === "PL") {
            this.state.animationsPageText = animationsPageText_pl;
            this.state.prefix = '/pl';
        }
        if (this.state.language === "SE") {
            this.state.animationsPageText = animationsPageText_se;
            this.state.prefix = '/se';
        }
        if (this.state.language === "NO") {
            this.state.animationsPageText = animationsPageText_no;
            this.state.prefix = '/nb';
        }
        if (this.state.language === "DK") {
            this.state.animationsPageText = animationsPageText_dk;
            this.state.prefix = '/dk';
        }
        if (this.state.language === "ES") {
            this.state.animationsPageText = animationsPageText_es;
            this.state.prefix = '/es';
        }
        if (this.state.language === "PT") {
            this.state.animationsPageText = animationsPageText_pt;
            this.state.prefix = '/pt';
        }
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_en,
                    prefix: ''
                });
            }
            if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_de,
                    prefix: '/de'
                });
            }
            if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_de_ch,
                    prefix: '/de-ch'
                });
            }
            if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_en_ca,
                    prefix: '/en-ca'
                });
            }
            if (this.props.language === "FR") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_fr,
                    prefix: '/fr-ch'
                });
            }
            if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_fr_ca,
                    prefix: '/fr-ca'
                });
            }
            if (this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_fr_fr,
                    prefix: '/fr'
                });
            }
            if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_nl,
                    prefix: '/nl'
                });
            }
            if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_it,
                    prefix: '/it'
                });
            }
            if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_it_ch,
                    prefix: '/it-ch'
                });
            }
            if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_cz,
                    prefix: '/cz'
                });
            }
            if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_fi,
                    prefix: '/fi'
                });
            }
            if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_pl,
                    prefix: '/pl'
                });
            }
            if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_se,
                    prefix: '/se'
                });
            }
            if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_no,
                    prefix: '/nb'
                });
            }
            if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_dk,
                    prefix: '/dk'
                });
            }
            if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_es,
                    prefix: '/es'
                });
            }
            if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    animationsPageText: animationsPageText_pt,
                    prefix: '/pt'
                });
            }
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
        if (!isDanaResourcesAvailable(this.props.language) && this.state.activeFilter === 'dana') {
            this.setState({ activeFilter: 'ypso', currentSlide: 0 });
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.addEventListener('mousedown', this.handleSortClickOutside);
        document.body.classList.remove('open-sort');
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleSortClickOutside);
        document.body.classList.remove('open-sort');
    }

    handleSortClickOutside(event) {
        if (this.sortContainer.current && !this.sortContainer.current.contains(event.target)) {
            this.setState({ sortDropdownOpen: false });
            document.body.classList.remove('open-sort');
        }
    }

    toggleSortDropdown() {
        this.setState(prevState => ({ sortDropdownOpen: !prevState.sortDropdownOpen }));
        document.body.classList.toggle('open-sort');
    }

    handleFilterChange(filter) {
        if (filter === 'dana' && !isDanaResourcesAvailable(this.state.language)) {
            return;
        }
        this.setState({ activeFilter: filter, currentSlide: 0 });
    }

    handleSortChange(sortValue) {
        this.setState({ sortBy: sortValue, sortDropdownOpen: false });
        document.body.classList.remove('open-sort');
    }

    nextSlide() {
        const filteredVideos = this.getFilteredVideos();
        const maxSlide = Math.max(0, Math.ceil(filteredVideos.length / 6) - 1);
        this.setState(prevState => ({
            currentSlide: prevState.currentSlide < maxSlide ? prevState.currentSlide + 1 : prevState.currentSlide
        }));
    }

    prevSlide() {
        this.setState(prevState => ({
            currentSlide: prevState.currentSlide > 0 ? prevState.currentSlide - 1 : 0
        }));
    }

    openVideo(video) {
        this.setState({ isVideoOpen: true, selectedVideo: video });
    }

    closeVideo() {
        this.setState({ isVideoOpen: false, selectedVideo: null });
    }

    getFilteredVideos() {
        let videos = this.state.animationsPageText.videos || [];
        const danaAvailable = isDanaResourcesAvailable(this.state.language);
        const activeFilter = (!danaAvailable && this.state.activeFilter === 'dana')
            ? 'ypso'
            : this.state.activeFilter;

        if (!danaAvailable) {
            videos = videos.filter(video => !isDanaOnlyResource(video));
        }

        if (usesMgDlGlucoseUnit(this.state.language)) {
            videos = videos.filter(video => !isMmolLAnimation(video));
        }
        if (usesMmolLGlucoseUnit(this.state.language)) {
            videos = videos.filter(video => !isMgDlAnimation(video));
        }

        // Filter by category
        if (activeFilter !== 'all') {
            videos = videos.filter(video => video.category === activeFilter);
        }
        
        // Sort videos
        if (this.state.sortBy === 'newest') {
            videos = [...videos].sort((a, b) => new Date(b.date) - new Date(a.date));
        } else if (this.state.sortBy === 'oldest') {
            videos = [...videos].sort((a, b) => new Date(a.date) - new Date(b.date));
        } else if (this.state.sortBy === 'a-z') {
            videos = [...videos].sort((a, b) => a.title.localeCompare(b.title));
        } else if (this.state.sortBy === 'popular') {
            videos = [...videos].sort((a, b) => (b.views || 0) - (a.views || 0));
        }
        
        return videos;
    }

    getYouTubeVideoId(url) {
        if (!url) return null;

        // Prefer explicit patterns so youtu.be IDs that start with "v"
        // are not truncated by the generic watch?v= optional-group regex.
        const patterns = [
            /youtu\.be\/([A-Za-z0-9_-]{11})/,
            /[?&]v=([A-Za-z0-9_-]{11})/,
            /\/embed\/([A-Za-z0-9_-]{11})/,
            /\/v\/([A-Za-z0-9_-]{11})/,
        ];

        for (const pattern of patterns) {
            const match = url.match(pattern);
            if (match && match[1]) {
                return match[1];
            }
        }

        return null;
    }

    isYouTubeUrl(url) {
        if (!url) return false;
        return url.includes('youtube.com') || url.includes('youtu.be');
    }

    getYouTubeThumbnail(url) {
        const videoId = this.getYouTubeVideoId(url);
        if (videoId) {
            return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        }
        return '/images/video-placeholder.svg';
    }

    getYouTubeWatchUrl(url) {
        const videoId = this.getYouTubeVideoId(url);
        return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{parse(this.state.animationsPageText.title)}</title>
                    <meta name="title" content={parse(this.state.animationsPageText.titleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.animationsPageText.descriptionMeta)}/>
                    <meta property="og:locale" content={this.state.animationsPageText.localeMeta}/>
                    <meta name="keywords" content={this.state.animationsPageText.keywords}/>
                </Helmet>
                <Header props={this.props}/>
                
                {/* Video Modal */}
                {this.state.isVideoOpen && this.state.selectedVideo && (
                    <div 
                        className="video-modal-overlay"
                        onClick={this.closeVideo}
                    >
                        <div 
                            className="video-modal-container"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Close Button */}
                            <button
                                onClick={this.closeVideo}
                                className="video-modal-close"
                            >
                                <svg 
                                    viewBox="0 0 18 18" 
                                    fill="none" 
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M1 1L17 17M17 1L1 17" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                <span>{parse(this.state.animationsPageText.closeButtonText || 'Close')}</span>
                        </button>
                            
                            {/* Video Container */}
                            <div className="video-modal-video-wrapper">
                                {this.isYouTubeUrl(this.state.selectedVideo.videoUrl) ? (
                                    <iframe
                                        className="video-modal-video"
                                        src={`https://www.youtube.com/embed/${this.getYouTubeVideoId(this.state.selectedVideo.videoUrl)}?autoplay=1&mute=0&rel=0&modestbranding=1&enablejsapi=1`}
                                        title={this.state.selectedVideo.title}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                        referrerPolicy="strict-origin-when-cross-origin"
                                    ></iframe>
                                ) : (
                        <video
                            controls
                            autoPlay
                                        className="video-modal-video"
                        >
                            <source src={this.state.selectedVideo.videoUrl} type="video/mp4" />
                            {parse(this.state.animationsPageText.videoNotSupportedText || 'Your browser does not support the video tag.')}
                        </video>
                                )}
                            </div>
                            {this.isYouTubeUrl(this.state.selectedVideo.videoUrl) && (
                                <p className="video-modal-youtube-fallback">
                                    <a
                                        href={this.getYouTubeWatchUrl(this.state.selectedVideo.videoUrl)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {parse(this.state.animationsPageText.watchOnYouTubeText || 'If the video does not play, watch on YouTube')}
                                    </a>
                                </p>
                            )}
                        </div>
                    </div>
                )}

                <section className="inner-banner user-training-page">
                    <div className="container">
                        <div className="justify-content-center">
                            <div className="user-training-header animations-page-header">
                                <h1>{parse(this.state.animationsPageText.mainHeader)}</h1>
                                <p>{parse(this.state.animationsPageText.mainSubHeader)}</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Filter Bar */}
                <section className="animations-filter-section">
                    <div className="container-fluid animations-filter-container">
                        <div className="animations-filter-wrapper">
                            {/* Filter Buttons */}
                            <div className="animations-filter-buttons">
                                {/* YpsoPump Filter */}
                                <button
                                    onClick={() => this.handleFilterChange('ypso')}
                                    className={`animations-filter-btn ${this.state.activeFilter === 'ypso' ? 'active' : ''}`}
                                >
                                    {parse(this.state.animationsPageText.filterYpsoPump || 'YpsoPump')}
                                    {this.state.activeFilter === 'ypso' && (
                                        <div className="animations-filter-indicator"></div>
                                    )}
                                </button>
                                
                                {isDanaResourcesAvailable(this.state.language) && (
                                <button
                                    onClick={() => this.handleFilterChange('dana')}
                                    className={`animations-filter-btn ${this.state.activeFilter === 'dana' ? 'active' : ''}`}
                                >
                                    {parse(this.state.animationsPageText.filterDana || 'Dana')}
                                    {this.state.activeFilter === 'dana' && (
                                        <div className="animations-filter-indicator"></div>
                                    )}
                                </button>
                                )}
                            </div>
                            
                            {/* Sort Dropdown - Matching Language Dropdown Style */}
                            <div className="animations-sort-dropdown" ref={this.sortContainer}>
                                <div className={`animations-sort-label ${this.state.sortDropdownOpen ? 'open-sort' : ''}`}>
                                    <input 
                                        type="checkbox" 
                                        id="sort-toggle"
                                        onClick={this.toggleSortDropdown}
                                    />
                                    <label htmlFor="sort-toggle">
                                        {this.state.sortBy === 'newest' ? (this.state.animationsPageText.sortNewest || 'Newest') :
                                         this.state.sortBy === 'oldest' ? (this.state.animationsPageText.sortOldest || 'Oldest') :
                                         this.state.sortBy === 'a-z' ? (this.state.animationsPageText.sortAZ || 'A-Z') :
                                         (this.state.animationsPageText.sortPopular || 'Most popular')}
                                    </label>
                                    {this.state.sortDropdownOpen && (
                                        <div className="animations-sort-list">
                                            <ul>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('newest');
                                                        }}
                                                        className={this.state.sortBy === 'newest' ? 'active' : ''}
                                                    >
                                                        {this.state.animationsPageText.sortNewest || 'Newest'}
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('oldest');
                                                        }}
                                                        className={this.state.sortBy === 'oldest' ? 'active' : ''}
                                                    >
                                                        {this.state.animationsPageText.sortOldest || 'Oldest'}
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('a-z');
                                                        }}
                                                        className={this.state.sortBy === 'a-z' ? 'active' : ''}
                                                    >
                                                        {this.state.animationsPageText.sortAZ || 'A-Z'}
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('popular');
                                                        }}
                                                        className={this.state.sortBy === 'popular' ? 'active' : ''}
                                                    >
                                                        {this.state.animationsPageText.sortPopular || 'Most popular'}
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Video Grid Slider */}
                <section className="animations-grid-section">
                    <div className="container-fluid animations-grid-container">
                        {/* Previous Button */}
                        {(() => {
                            const isDisabled = this.state.currentSlide === 0;
                            return (
                                <button
                                    onClick={this.prevSlide}
                                    className={`animations-nav-button animations-nav-prev ${isDisabled ? 'disabled' : ''}`}
                                    disabled={isDisabled}
                                    aria-label={this.state.animationsPageText.ariaPrevSlide || "Previous slide"}
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15 18L9 12L15 6" stroke="#04ABA0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            );
                        })()}
                        
                        {/* Next Button */}
                        {(() => {
                            const filteredVideos = this.getFilteredVideos();
                            const maxSlide = Math.max(0, Math.ceil(filteredVideos.length / 6) - 1);
                            const isDisabled = this.state.currentSlide >= maxSlide;
                            return (
                                <button
                                    onClick={this.nextSlide}
                                    className={`animations-nav-button animations-nav-next ${isDisabled ? 'disabled' : ''}`}
                                    disabled={isDisabled}
                                    aria-label={this.state.animationsPageText.ariaNextSlide || "Next slide"}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            );
                        })()}
                        
                        {/* Video Grid */}
                        <div
                            className="animations-grid-slider-wrapper"
                            onTouchStart={this.handleGridTouchStart}
                            onTouchEnd={this.handleGridTouchEnd}
                        >
                            <div 
                                className="animations-grid-slider"
                                style={{ transform: `translateX(-${this.state.currentSlide * 100}%)` }}
                            >
                                {(() => {
                                    const filteredVideos = this.getFilteredVideos();
                                    const slides = [];
                                    for (let i = 0; i < filteredVideos.length; i += 6) {
                                        slides.push(filteredVideos.slice(i, i + 6));
                                    }
                                    return slides.map((slideVideos, slideIndex) => (
                                        <div key={slideIndex} className="animations-grid-slide">
                                                    {slideVideos.map((video, index) => (
                                                <div key={index} className="animations-video-card">
                                                    {/* Video Thumbnail */}
                                                    <div 
                                                        className="animations-video-thumbnail-wrapper"
                                                        onClick={() => this.openVideo(video)}
                                                    >
                                                        <img
                                                            src={this.isYouTubeUrl(video.videoUrl) ? this.getYouTubeThumbnail(video.videoUrl) : video.thumbnail}
                                                            alt={video.title}
                                                            title={video.title}
                                                            className="animations-video-thumbnail"
                                                        />
                                                        
                                                        {/* Video Icon Badge - only show when duration is available */}
                                                        {video.duration && (
                                                            <div className="animations-video-badge">
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M2 2H8L10 4H14C14.5304 4 15.0391 4.21071 15.4142 4.58579C15.7893 4.96086 16 5.46957 16 6V12C16 12.5304 15.7893 13.0391 15.4142 13.4142C15.0391 13.7893 14.5304 14 14 14H2C1.46957 14 0.960859 13.7893 0.585786 13.4142C0.210714 13.0391 0 12.5304 0 12V4C0 3.46957 0.210714 2.96086 0.585786 2.58579C0.960859 2.21071 1.46957 2 2 2ZM6 5.5V10.5L11 8L6 5.5Z" fill="white"/>
                                                                </svg>
                                                                <span className="animations-video-badge-text">{video.duration}</span>
                                                            </div>
                                                        )}
                                                        
                                                        {/* Play Icon Overlay */}
                                                        <div className="animations-play-button-overlay play-button">
                                                            <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M18 12L1 23V1L18 12Z" fill="#04ABA0" stroke="#04ABA0" strokeWidth="2"/>
                                                            </svg>
                                                        </div>
                                                    </div>

                                                    {/* Video Info */}
                                                    <div className="animations-video-info">
                                                       
                                                        <h3 className="animations-video-title">
                                                            {parse(video.title)}
                                                        </h3>
                                                        {(video.date || video.duration) && (
                                                            <p className="animations-video-meta">
                                                                {[video.date, video.duration].filter(Boolean).join(' | ')}
                                                            </p>
                                                        )}
                                                        {/*
                                                        <p className="animations-video-description">
                                                            {parse(video.description)}
                                                        </p>
                                                        */}
                                                    </div>
                                                    
                                                    {/* Divider Line */}
                                                    <div className="animations-video-divider"></div>
                                                </div>
                                            ))}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>

                        {/* Pagination Dots */}
                        {(() => {
                            const filteredVideos = this.getFilteredVideos();
                            const totalSlides = Math.ceil(filteredVideos.length / 6);
                            if (totalSlides > 1) {
                                return (
                                    <div className="animations-pagination">
                                        {Array.from({ length: totalSlides }, (_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => this.setState({ currentSlide: index })}
                                                className={`animations-pagination-dot ${this.state.currentSlide === index ? 'active' : ''}`}
                                                aria-label={(this.state.animationsPageText.ariaGoToSlide || "Go to slide {n}").replace("{n}", String(index + 1))}
                                            />
                                        ))}
                                    </div>
                                );
                            }
                            return null;
                        })()}
                    </div>
                </section>

                {/* Getting Started Section */}
                <section className="getting-started-section">
                    <div className="container-lg">
                        <div className="row">
                            {/* Left Column */}
                            <div className="col-12 col-lg-6">
                                {/* Title */}
                                <h2>{parse(this.state.animationsPageText.gettingStartedHeader || 'Ready to get started?')}</h2>

                                {/* Step 1 */}
                                <div className="getting-started-step">
                                    <h3 className="step-title">
                                        <p>{parse(this.state.animationsPageText.step1Title || '<strong>Step 1:</strong> Download the app')}</p>
                                    </h3>
                                    <div className="logo-container">
                                        <a href={GOOGLE_PLAY_APP_URL} 
                                           target="_blank" 
                                           rel="noopener noreferrer">
                                            <img src="/images/google-play-badge.png" 
                                                 alt={this.state.animationsPageText.altGooglePlay || "Get it on Google Play"} />
                                        </a>
                                        <a href={APPLE_APP_STORE_URL} 
                                           target="_blank" 
                                           rel="noopener noreferrer">
                                            <img src="/images/app-store.png" 
                                                 alt={this.state.animationsPageText.altAppStore || "Download on App Store"} />
                                        </a>
                                    </div>
                                </div>

                                {/* Step 2 */}
                                <div className="getting-started-step step-2">
                                    <h3>
                                        <p>{parse(this.state.animationsPageText.step2Title || '<strong>Step 2:</strong> Create an account')}</p>
                                    </h3>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div className="col-12 col-lg-6">
                                {/* Step 3 */}
                                <div className="getting-started-step step-3">
                                    <h3>
                                        <p>{parse(this.state.animationsPageText.step3Title || '<strong>Step 3:</strong> Begin the in-app essential training')}</p>
                                    </h3>
                                </div>

                                {/* Step 4 */}
                                <div className="getting-started-step step-4">
                                    <h3>
                                        <p>
                                            {parse(this.state.animationsPageText.step4Title || '<strong>Step 4:</strong> Pair with your chosen pump and CGM (with the approval of your healthcare team) or explore the app with <strong>Virtual Mode</strong>')}
                                            <span className="tooltip-wrapper">
                                                <span className="tooltip-container">
                                                    <img 
                                                        src="/images/info-circle.svg" 
                                                        alt={this.state.animationsPageText.altInfo || "Info"}
                                                        className="tooltip-icon"
                                                    />
                                                    <span className="tooltip-text">
                                                        {parse(this.state.animationsPageText.virtualModeTooltipText || 'Virtual mode allows you to trial the app without being connected to a real insulin pump and CGM sensor.')}
                                                    </span>
                                                </span>
                                            </span>
                                        </p>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Support Section */}
                <section className="support-section">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            {/* Help Icon */}
                            <div className="col-12 col-lg-auto d-flex justify-content-center justify-content-lg-start">
                                <img 
                                    src="/images/help-icon.svg" 
                                    alt={this.state.animationsPageText.altHelp || "Help"}
                                    className="help-icon"
                                />
                            </div>

                            {/* Text Content */}
                            <div className="col-12 col-lg">
                                <h3 style={{ marginBottom: '8px', lineHeight: '1.171875' }}>
                                    {parse(this.state.animationsPageText.supportSectionTitle || 'Need help installing the app?')}
                                </h3>
                                <p style={{ margin: '0', lineHeight: '1.171875' }}>
                                    {parse(this.state.animationsPageText.supportSectionText || 'Visit our support section for guidance.')}
                                </p>
                            </div>

                            {/* Support Button */}
                            <div className="col-12 col-lg-auto d-flex justify-content-center justify-content-lg-end">
                                <a 
                                    href={this.state.prefix + "/support"}
                                    className="support-button support-button-rounded"
                                >
                                    {parse(this.state.animationsPageText.supportButtonText || 'SUPPORT')}
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                
                <Footer props={this.props}/>
            </div>
        );
    }
}

